import moment from 'moment'
import {
    v1 as uuidv1,
} from 'uuid'
import {
    Domain, ValueMappingResponse,
} from 'app/requests/ValueMapping/ValueMapping.types'
import {
    ForecastData,
} from 'app/requests/Forecast/Forecast.types'
import dateMask from 'app/utils/date/dateMask'
import {
    ForecastCreatePreparedData,
    ForecastCreateRawData,
} from '../ShortTermForecastCsvUpload.types'
import {
    propertiesToDomainMap,
} from '../ShortTermForecast.constants'
import {
    DATE_REGEX,
} from './validateForecastCsv'

// rename [from] : [to]
const keysToRename: Record<keyof ForecastCreateRawData, keyof ForecastCreatePreparedData> = {
    accountName: 'account',
}

const parseForecastCsvData = (
    data: ForecastCreateRawData[],
    idMap: Map<Domain, ValueMappingResponse[]>,
): ForecastCreatePreparedData[] => {
    return data.map((record) => {
        const forecasts: ForecastData[] = []
        const cleanedRecord = {
            tempId: uuidv1(),
            ...record,
        } as unknown as ForecastCreatePreparedData

        Object.entries(record).forEach(([
            key,
            value,
        ]) => {
            if (DATE_REGEX.test(key)) {
                // Check if the key is a date (forecast date)
                forecasts.push({
                    year: moment(key, dateMask).year(),
                    month: moment(key, dateMask).month() + 1,
                    units: value,
                })
                delete cleanedRecord[key]
            } else if (Object.keys(propertiesToDomainMap).includes(key)) {
                // Check if the key maps to id
                const mappedValue = (idMap.get(propertiesToDomainMap[key]) || []).find(
                    ({
                        label,
                    }) => {
                        return label === value
                    },
                )

                if (mappedValue) {
                    cleanedRecord[key] = {
                        id: mappedValue.id,
                    }
                    cleanedRecord[`${key}Label`] = mappedValue.label
                } else {
                    cleanedRecord[key] = null
                    cleanedRecord[`${key}Label`] = value
                }
            }

            if (keysToRename[key]) {
                const newKey = keysToRename[key]

                cleanedRecord[newKey as any] = cleanedRecord[key]
                delete cleanedRecord[key]
            }
        })

        return {
            ...cleanedRecord,
            forecasts,
        }
    })
}

export default parseForecastCsvData
